"use strict";

angular.module('app.factories.functions', []).// app.factories.info-module
// -------------------------------------------//
//              Favorites Factory
// -------------------------------------------//

factory('f_Functions', ['$translate', '$rootScope',
    function ($translate, $rootScope) {

        var obj = {


            // -------------------------------------------//
            //              Place obj in list at Position an reorder
            // -------------------------------------------//
            sortListBy: function (list, prop) {
                list.sort(function (a, b) {
                    if (a.value > b.value) {
                        return 1;
                    }
                    if (a.value < b.value) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                });
                return obj;
            },
            addElement: function (type, list, args) {
                switch (type) {

                    case 'MenuEntry':
                        var el = [];
                        el = {
                            'MenuEntryId': 'Pending',
                            "ImageName": 'ordner',
                            'add': 'MenuEntry',
                            'editmode': true,
                            'MenuEntryType': 0,
                            'IconName': null,
                            "DisplayName": "GENERAL_NewMenuEntryName",
                            "Sort": list.length,
                            "ParentMenuEntryId": args.ParentMenuEntryId
                        };
                        list.push(el);
                        if (args && args.ParentMenuEntryId) {
                            el.ParentMenuEntryId = args.ParentMenuEntryId
                        }
                        ;
                        $translate(el.DisplayName).then(function (translation) {
                            el.DisplayName = translation;
                        });
                        break;

                    case "Device":
                        el = [];
                        el = {
                            'DeviceId': 'Pending',
                            'add': 'Device',
                            'editmode': true,
                            "Name": "GENERAL_NewDeviceName"
                        };
                        if (args && args.ParentMenuEntryId) {
                            el.ParentMenuEntryId = args.ParentMenuEntryId
                        }
                        ;
                        if (args && args.ParentDeviceId) {
                            el.ParentDeviceId = args.ParentDeviceId
                        }
                        ;
                        list.push(el);
                        $translate(el.Name).then(function (translation) {
                            el.Name = translation;
                        });
                        break;
                }
                return el;
            },

            initButtons: function (o) {
                if (o.Back != undefined && o.Back == true) {
                    $rootScope.backbutton = true;
                } else {
                    $rootScope.backbutton = false;
                }
            }
        };
        return obj;
    }]);
	